/** Maps Stables operation id to `/v1/stables/limits` item id. */
export const OPERATION_LIMIT_IDS = {
  buy: "compra",
  sell: "venda",
  swap: "swap",
  withdraw: "saque-onchain",
};

export const getOperationLimitId = (operation) => OPERATION_LIMIT_IDS[operation] ?? null;

/** Disponível em centavos: prefers API `available_cents`, else totalCents - usedCents. */
export const resolveLimitAvailableCents = (limit = {}) => {
  const explicit = limit.availableCents ?? limit.available_cents;
  if (explicit != null && Number.isFinite(Number(explicit))) {
    return Math.max(0, Math.round(Number(explicit)));
  }

  const totalCents = Number(limit.totalCents ?? limit.total_cents) || 0;
  const usedCents = Number(limit.usedCents ?? limit.used_cents) || 0;
  return Math.max(0, totalCents - usedCents);
};

export const calcLimitPercent = (usedCents, totalCents) => {
  if (!totalCents || totalCents <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((usedCents / totalCents) * 100)));
};

export const getLimitTone = (percent) => {
  if (percent >= 90) return "alert";
  if (percent >= 75) return "gold";
  return "success";
};
